import { Box } from "@mui/material";
import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { GlobalContext } from "../../context/globalContext";
import "./_style.scss";
import { httpAPI_ACC002, httpAPI_ACC004 } from "./api/request";
import { fakeTableList, schema } from "./parts";
import _ from "lodash";

/**
 * SCRW100002_契約者アカウント詳細・更新
 * @return SCRW100002_契約者アカウント詳細・更新
 */
const SCRW100002 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const [loginId, setLoginId] = useState<any>();

  const [statecorpInfoList, setStatecorpInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  const handleInit = async () => {
    try {
      // 法人ユーザ参照API
      let res = await httpAPI_ACC002({
        userId: location.state?.userId,
      });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList.current;
        // ログインID
        resArr.find((item) => item.keyword === "loginId")!.text = res.userId;
        // ステータス
        resArr.find((item) => item.keyword === "status")!.setDefaultValue =
          res.status;
        // 契約者名：
        resArr.find((item) => item.keyword === "contractorName")!.text =
          (res.contractorNo ?? "") + "：" + (res.corpName ?? "");
        // 利用者名
        let userName = resArr.find((item) => item.keyword === "userName")!;
        userName.setDefaultValue = res.name;

        // 連絡先
        resArr.find((item) => item.keyword === "contact")!.setDefaultValue =
          res.email;
        // 連絡先
        resArr.find(
          (item) => item.keyword === "contactConfirm"
        )!.setDefaultValue = res.email;

        setStatecorpInfoList([...resArr]);
        setLoginId(res.userId);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 更新
  const handleUpdate = async (data: any) => {
    try {
      let res = await httpAPI_ACC004({
        userId: loginId,
        name: data.userName,
        email: data.contact,
        status: data.status,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW100001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRW100002test" className="SCRW100002">
      <TkFakeTable
        list={statecorpInfoList}
        ruleSchema={schema}
        buttonGroup={<TkBackButton />}
        submitButtonText="更新"
        onCheckAndSubmit={handleUpdate}
      />
    </Box>
  );
};

export default SCRW100002;
